import Component from '../abstracts/Component';
import FixBody from '../utils/FixBody';

export default class CategoryFilterComponent extends Component {
  get SELECTORS() {
    return {
      showMore: '.w-sales__micro-category [data-show-more]',
      showLess: '.w-sales__micro-category [data-show-less]',
      secondaryList: '.w-sales__micro-category [data-secondary-list]',
      submenuPanel: '.w-sales__micro-category [data-submenu-panel]',
      submenuPanelClose: '.w-sales__micro-category [data-trigger-close]',
      benefitBar: '.w-sales__micro-category [data-benefit-bar]',
    };
  }
  constructor(htmlEl) {
    super(htmlEl);
    this.showMore = document.querySelector(this.SELECTORS.showMore);
    this.showLess = document.querySelector(this.SELECTORS.showLess);
    this.secondaryList = document.querySelector(this.SELECTORS.secondaryList);
    this.submenuPanel = document.querySelector(this.SELECTORS.submenuPanel);
    this.submenuPanelClose = document.querySelector(this.SELECTORS.submenuPanelClose);
  }

  render() {
    this.bindEvents();
  }

  bindEvents() {
    let scrollY = 0;
    let benefitBar = document.querySelector(this.SELECTORS.benefitBar);
    let barHeight = benefitBar ? benefitBar.offsetHeight : 0;
    if (this.showMore != null) {
      this.showMore.addEventListener('click', () => {
        if (window.matchMedia('(min-width: 768px)').matches) {
          this.showMore.style.display = 'none';
          this.secondaryList.style.display = 'block';
        } else {
          this.submenuPanel.classList.add('open');
          scrollY = window.scrollY > barHeight ? window.scrollY : barHeight;
          FixBody.block(barHeight);
        }
      });
    }
    if (this.showLess != null) {
      this.showLess.addEventListener('click', () => {
        if (window.matchMedia('(min-width: 768px)').matches) {
          this.showMore.style.display = 'block';
          this.secondaryList.style.display = 'none';
        }
      });
    }
    if (this.submenuPanelClose != null) {
      this.submenuPanelClose.addEventListener('click', () => {
        this.submenuPanel.classList.remove('open');
        FixBody.unblock(scrollY);
      });
    }
  }
}
